import Repository from '@/repositories/marketing'
const resource = '/sms_keywords'

export default {
  // Index UI and Filter
  fetchAllKeywords (config) {
    return Repository.get(`${resource}.json`, config)
  },
  /**
   * @desc: Handle Create|Update APIs - START
  */
  fetchKeywordActions(config) {
    return Repository.get(`${resource}/actions.json`, config)
  },
  findSMSContactList(config) {
    return Repository.get(`${resource}/search_sms_contact_list.json`, config)
  },
  fetchKeywordDetail(keywordId, config) {
    return Repository.get(`${resource}/${keywordId}.json`, config)
  },
  updateKeyword(keywordId, payload, config) {
    return Repository.put(`${resource}/${keywordId}.json`, payload, config)
  },
  createKeyword(payload, config) {
    return Repository.post(`${resource}.json`, payload, config)
  },
  fetchSMSContactLists(config) {
    return Repository.get(`${resource}/sms_lists.json`, config)
  },
  /**
  * @desc: Invalid Message Response APIs - START
  */
  fetchInvalidResponseData(config) {
    return Repository.get('/invalid_sms_response_message.json', config)
  },
  saveInvalidResponse(payload, config) {
    return Repository.post('/invalid_sms_response_message.json', payload, config)
  },
  /**
  * Invalid Message Response APIs - END
  */
  /**
  * @desc: Service to load contact tags for SMS Campaign builder and Mobile keywords
  */
  fetchKeywordContactTags (config) {
    return Repository.get('/contact_tags.json', config)
  },
  fetchSmsCampaigns(keywordId, config){
    return Repository.get(`${resource}/${keywordId}/sms_campaigns.json`, config)
  },
  fetchClickOverview(keywordId,config){
    return Repository.get(`${resource}/${keywordId}/sms_urls.json`, config)
  },
  fetchDetailedReport(keywordId,config){
    return Repository.get(`${resource}/${keywordId}/sms_campaign_clicks.json`, config)
  }
}
